export default {
  shippingStep: {
    id: 'in_store_checkout_funnel_page_step_shipping',
    defaultMessage: 'Shipping',
  },
  paymentStep: {
    id: 'in_store_checkout_funnel_page_step_payment',
    defaultMessage: 'Payment',
  },
  previousPage: {
    id: 'in_store_checkout_funnel_page_previous_page',
    defaultMessage: 'Back to previous page',
  },
  stepperClose: {
    id: 'in_store_checkout_funnel_page_stepper_close',
    defaultMessage: 'Close',
  },
  stepperCompleted: {
    id: 'in_store_checkout_funnel_page_stepper_completed',
    defaultMessage: 'Completed',
  },
  stepperCurrent: {
    id: 'in_store_checkout_funnel_page_stepper_current',
    defaultMessage: 'Current',
  },
  cartStep: {
    id: 'in_store_checkout_funnel_page_step_cart',
    defaultMessage: 'Cart',
  },
  confirmationStep: {
    id: 'in_store_checkout_funnel_page_step_confirmation',
    defaultMessage: 'Confirmation',
  },
}
